import React, { FC } from "react";
import { ButtonStyled, ButtonsWrapper } from "./elements";

type Props = {
  current: number;
  previous: () => void;
  onSubmitPersonalProfile: () => void;
  onSubmitSkills: () => void;
  onSubmitContacts: () => void;
  onSubmitPreScreening: () => void;
  acceptInformation: boolean;
  buttonLoading?: boolean | undefined;
};

const ApplicantDetailsButton: FC<Props> = props => {
  const {
    current,
    previous,
    onSubmitPersonalProfile,
    onSubmitSkills,
    onSubmitContacts,
    onSubmitPreScreening,
    acceptInformation,
    buttonLoading,
  } = props;

  return (
    <ButtonsWrapper>
      {current > 0 && (
        <ButtonStyled id="grayButton" type="primary" onClick={previous}>
          Back
        </ButtonStyled>
      )}
      {current === 0 && (
        <ButtonStyled type="primary" onClick={onSubmitPersonalProfile}>
          Next
        </ButtonStyled>
      )}
      {current === 1 && (
        <ButtonStyled type="primary" onClick={onSubmitSkills}>
          Next
        </ButtonStyled>
      )}
      {current === 2 && (
        <ButtonStyled type="primary" onClick={onSubmitContacts}>
          Next
        </ButtonStyled>
      )}
      {current === 3 && (
        <ButtonStyled
          type="primary"
          onClick={onSubmitPreScreening}
          disabled={!acceptInformation}
          loading={buttonLoading || false}
        >
          Finish
        </ButtonStyled>
      )}
    </ButtonsWrapper>
  );
};

export default ApplicantDetailsButton;
